import { useMutation } from '@apollo/client/react';
import { Button } from 'components/ui';
import { useInfo } from 'contexts/info';
import { useError } from 'contexts/error';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { PlacesLink } from 'utils/link';
import DeleteMutation from 'mutations/place/delete';
import Confimation from 'components/form/confirmation';

const DeleteButton = ({ place, space, size = 'medium' }) => {
  const setInfo = useInfo();
  const setError = useError();
  const navigate = useNavigate();

  const [deleteMutation, deleteMutationData] = useMutation(DeleteMutation, {
    onCompleted: () => {
      setInfo('info.place.deleted');
      navigate(PlacesLink());
    },
    onError: () => {
      setError('error.place.delete');
    },
  });

  return (
    <Confimation
      title={<FormattedMessage id="header.place.delete" />}
      description={<FormattedMessage id="confirmation.place.delete" />}
      onClick={() => {
        deleteMutation({ variables: { id: place.id } });
      }}
    >
      <Button
        size={size}
        color="error"
        variant="outlined"
        disabled={deleteMutationData.loading || !space.adminRole}
      >
        <FormattedMessage id="button.delete" />
      </Button>
    </Confimation>
  );
};

export default DeleteButton;
